import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { BusinessUnit } from '@common/models';
import { Column, DataTableInput, DataTableOutput, Order, PagedData, Search } from '@core/models/datables';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class BusinessUnitService {

  private columns: Column[] = [
    {
      data: "name",
      name: "Nombre",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "code",
      name: "Codigo",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: "company.name",
      name: "Empresa",
      searchable: true,
      orderable: true,
      search: new Search()
    },
    {
      data: null,
      name: "Fecha",
      searchable: false,
      orderable: false,
      search: new Search()
    },
    {
      data: "status.name",
      name: "Status",
      searchable: true,
      orderable: true,
      search: new Search()
    }
  ];

  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) { }

  /**
   * Get all roles
   */
  getAll(page: number, quantity: number) {
    return this._http.get<PagedData<BusinessUnit>>(`${environment.commonApiUrl}/api/business-unit/page/${page}/${quantity}`);
  }

  getAllBusinessUnits(page: number, quantity: number, order: Order, searchText: string) {
    const input = this.createDataTableInput(page, quantity, order, searchText);
    return this._http.post<DataTableOutput<BusinessUnit>>(`${environment.commonApiUrl}/api/business-unit/index`, input);
  }


  getBusinessUnitByName(name: string){
    return this._http.get<BusinessUnit[]>(`${environment.commonApiUrl}/api/business-unit-filter/${name}`);
  }

  /**
   * Get role by id
   */
  getById(id: number) {
    return this._http.get<BusinessUnit>(`${environment.commonApiUrl}/api/business-unit/${id}`);
  }

  addBusinessUnit(role) {
    return this._http.post<BusinessUnit>(`${environment.commonApiUrl}/api/business-unit`, role).pipe(
      map((response: any) => response.role as BusinessUnit),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editBusinessUnit(role) {
    return this._http.put<BusinessUnit>(`${environment.commonApiUrl}/api/business-unit/${role.id}`, role).pipe(
      map((response: any) => response.role as BusinessUnit),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, newStatusId: number) {
    return this._http.put<BusinessUnit>(`${environment.commonApiUrl}/api/business-unit/${id}/${newStatusId}`, {}).pipe(
      map((response: any) => response.role as BusinessUnit),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función que crea una entrada para datatable por medio de parametros
   * @param page Indica el número de página
   * @param quantity Indica la cantidad de unidades a solicitar
   * @param order Indica el orden que tendrá la columna
   * @param searchText Indica el texto que se va a filtrar
   * @returns Devuelve una entrada para datatable
   */
  private createDataTableInput(page: number, quantity: number, order: Order, searchText: string): DataTableInput {
    let input = new DataTableInput();
    input.start = page * quantity;
    input.length = quantity;
    if (searchText !== '') {
      input.search.regex = true;
      input.search.value = searchText;
    }
    if (order) {
      input.order.push(order);
    }
    input.columns = this.columns;
    return input;
  }

}
